/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function linkedPoliticalCampaignRefs(advertiser: any): any[] {
  return _.filter(_.map(_.get(advertiser, 'politicalCampaigns') || [], function(campaign) {
    if (_.isString(campaign)) {
      return {publicId: campaign};
    }
    if (_.isObject(campaign)) {
      const campaignObj: any = campaign;
      return {
        id: campaignObj.id,
        name: campaignObj.name,
        publicId: campaignObj.publicId
      };
    }
    return null;
  }), function(campaign) {
    return campaign && !!campaign.publicId;
  });
}

export function buildTopicsFromPoliticalBudgets(advertiser: any): any {
  let topicsByElection: any = null;
  const politicalBudgets = _.get(advertiser, 'politicalBudgets') || [];

  _.forEach(politicalBudgets, function(politicalBudget) {
    const electionId = _.get(politicalBudget, ['election', 'id']);
    if (!electionId) {
      return;
    }
    topicsByElection = topicsByElection || {};
    topicsByElection[electionId] = Object.keys(politicalBudget.campaigns || {});
  });

  return topicsByElection;
}

export function topicsByElectionFromCampaigns(campaigns: any): any {
  const topicsByElection: any = {};

  _.forEach(campaigns, function(campaign) {
    const electionId = _.get(campaign, ['election', 'id']);
    if (!electionId) {
      return;
    }
    const topics = _.compact(_.map(campaign.topics || [], function(topic) {
      return topic.name || topic.id;
    }));
    topicsByElection[electionId] = _.uniq(_.concat(topicsByElection[electionId] || [], topics));
  });

  return _.isEmpty(topicsByElection) ? null : topicsByElection;
}

export function loadPoliticalCampaignTopicsByElection(refs: any[], PublicPoliticalCampaign: any): any {
  if (!refs.length) {
    return Promise.resolve(null);
  }

  return Promise.all(_.map(refs, function(ref) {
    return PublicPoliticalCampaign.get({id: ref.publicId}).$promise.then(function(campaign: any) {
      return campaign;
    }, function() {
      return null;
    });
  })).then(function(campaigns: any) {
    return topicsByElectionFromCampaigns(_.compact(campaigns));
  });
}

export function advertiserNeedsPoliticalData(advertiser: any): boolean {
  if (!advertiser || !advertiser.id) {
    return false;
  }
  return !_.has(advertiser, 'politicalBudgets') && !_.has(advertiser, 'politicalCampaigns');
}
